export default __webpack_public_path__ + "7e621e8a6fcc5754496716cd17751305.woff";